import { useQuery } from '@apollo/client';
import { Separator, Stack } from '@fluentui/react';
import { NoDataView } from 'common/components/DataPlaceholders';
import { DocumentList } from 'common/components/DocumentList';
import React from 'react';
import { SupplierUploadDocument_supplierUploadDocument } from 'settings/account/supplier/view/ActionMenu/SupplierAttach/UploadForm/__generated__/SupplierUploadDocument';
import { SupplierAvailableDocumentTypes } from 'settings/account/supplier/view/ActionMenu/SupplierAttach/__generated__/SupplierAvailableDocumentTypes';
import { AttachForm } from './AttachForm';
import { columns } from 'common/components/ActionMenu/Attach/coloumn.data';
import { useStyles } from './index.styles';
import { UploadForm } from './UploadForm';
import { SupplierSecureRowLevels } from 'common/graphql/__generated__/SupplierSecureRowLevels';
import { TASupplierDetails_supplier } from '../../../__generated__/TASupplierDetails';

import SUPPLIER_SECURE_ROW_LEVELS from 'common/graphql/SupplierSecureRowLevels.graphql';
import SUPPLIER_AVAILABLE_DOCUMENT_TYPES from '../../../../../../../../../../settings/account/supplier/view/ActionMenu/SupplierAttach/SupplierAvailableDocumentTypes.graphql';

interface AttachProps {
  supplier: TASupplierDetails_supplier;
  onRemove?: () => void;
  onUpload?: (
    fileSelected: File,
    documentData: SupplierUploadDocument_supplierUploadDocument,
    toastId: string
  ) => void;
}

export const Attach: React.FC<AttachProps> = ({
  supplier,
  onUpload,
  onRemove,
}) => {
  const styles = useStyles();
  const { data: supplierSecureRowLevels } = useQuery<SupplierSecureRowLevels>(
    SUPPLIER_SECURE_ROW_LEVELS,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-only',
    }
  );

  const { data: availableDocumentTypes } =
    useQuery<SupplierAvailableDocumentTypes>(
      SUPPLIER_AVAILABLE_DOCUMENT_TYPES,
      {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-only',
      }
    );

  return (
    <Stack tokens={{ childrenGap: 10 }} className={styles.mainStack}>
      {supplier?.entityDocumentsByEntityId?.nodes.length! > 0 && (
        <Stack
          tokens={{
            childrenGap: 10,
          }}
        >
          <DocumentList
            isNew={false}
            data={supplier?.entityDocumentsByEntityId?.nodes || []}
            isDeleteButtonVisible
            isShareAndProtectButtonsVisible
            secureRowLevel={supplierSecureRowLevels?.secureRowLevels?.nodes}
            onRemoveRow={(data) => {
              onRemove?.();
            }}
            columns={columns}
          />
        </Stack>
      )}
      <Stack tokens={{ padding: '0px 25px' }}>
        <NoDataView
          show={supplier?.entityDocumentsByEntityId.totalCount === 0}
          title="No Attachments"
        />
      </Stack>
       <Stack
        horizontal
        horizontalAlign="end"
        verticalAlign="center"
        tokens={{
          childrenGap: 10,padding:'0px 16px'
        }}
      >
        <AttachForm
          availableDocumentTypes={availableDocumentTypes}
          supplier={supplier}
        />
        <Separator vertical />
        <UploadForm
          availableDocumentTypes={availableDocumentTypes}
          supplier={supplier}
          onUpload={onUpload}
        />
      </Stack>
    </Stack>
  );
};
